// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sectionbox-loading-content{filter:blur(1.5px);-webkit-filter:blur(1.5px);pointer-events:none}", ""]);
// Exports
module.exports = exports;
